import { TransactionTicketDTO } from '@/api/trafikportalen';
import { FormattedMessage } from 'react-intl';
import { cn } from '@/helpers/classnames';
import { formatCardNumber } from '@/helpers/formatting';

interface OriginalBearerInfoProps {
  transactionTicket: TransactionTicketDTO;
  indentClass?: string;
}

export const OriginalBearerInfo = ({
  transactionTicket,
  indentClass,
}: OriginalBearerInfoProps) => {
  if (!transactionTicket.original_bearer) {
    return null;
  }

  return (
    <div className={cn('break-words text-text-700', indentClass)}>
      <span>
        <FormattedMessage defaultMessage="Ursprunglig bärare" />:
      </span>{' '}
      <span
        className={cn(
          transactionTicket.original_bearer_type === 'smartcard'
            ? 'font-mono'
            : 'font-normal',
        )}
      >
        {transactionTicket.original_bearer_type === 'smartcard' ? (
          formatCardNumber(transactionTicket.original_bearer)
        ) : (
          <>
            <FormattedMessage defaultMessage="Smartphone" /> (
            {transactionTicket.original_bearer})
          </>
        )}
      </span>
    </div>
  );
};
